import MailboxJunkEmailConfigurationState from './schema/MailboxJunkEmailConfigurationState';
import { createStore } from 'satcheljs';

export default createStore<MailboxJunkEmailConfigurationState>('calendarConfiguration', {
    mailboxJunkEmailConfiguration: null,
})();
